function querySelector(selector: `#${string}`): HTMLElement | null;
function querySelector(selector: string): NodeListOf<HTMLElement>;
function querySelector(selector: string) {
	if (selector.startsWith("#")) return document.querySelector(selector);
	else return document.querySelectorAll(selector);
}

export default querySelector;
